<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('customerProfile.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('customerProfile.pageTitle'),
            active: true,
          },
        ]"
      />
    </div>
    <div class="row">
      <div class="col-md-12">
        <ts-card>
          <ts-card-wrapper>
            <div class="d-flex justify-content-end">
              <div class="d-flex">
                <ts-button
                  color="success"
                  outline
                  :waiting="downloading"
                  @click.prevent="onDownload"
                  class="mr-2"
                  ><i class="far fa-file-excel"></i>
                  {{ $t('export') }}</ts-button
                >
                <a-range-picker
                  class="ts-w-full"
                  valueFormat="DD-MM-YYYY"
                  format="DD-MM-YYYY"
                  v-model="model.date"
                />
                <ts-input
                  v-model="search"
                  :placeholder="$t('search')"
                  style="width: 250px"
                  class="ml-2 inline-block"
                />
              </div>
            </div>
          </ts-card-wrapper>
          <div id="list" class="ts-overflow-scroll">
            <ts-table
              :columns="columns"
              :records="resources"
              :loading="loading"
            >
              <template v-slot="{ record }">
                <td class="ts-whitespace-no-wrap">
                  {{ record.customer_name }}
                </td>
                <td class="ts-whitespace-no-wrap text-center">
                  {{ record.phone_number }}
                </td>
                <td class="ts-whitespace-no-wrap text-center">
                  {{ record.year_of_born }}
                </td>
                <td class="ts-whitespace-no-wrap">
                  {{ record.locations }}
                </td>
                <td class="ts-whitespace-no-wrap text-right">
                  {{ record.balance | format_number }}
                </td>
                <td class="ts-whitespace-no-wrap text-center">
                  {{ record.registered_date }}
                </td>
                <td class="ts-whitespace-no-wrap text-center">
                  <i
                    class="fa fa-check text-success"
                    v-if="record.is_active"
                  ></i>
                  <i class="fa fa-times text-red" v-else></i>
                </td>
              </template>
            </ts-table>
          </div>
          <ts-card-wrapper>
            <div class="d-flex justify-content-end p-15">
              <ts-pagination
                v-model="pagination"
                @navigate="fetchData"
              ></ts-pagination>
            </div>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>
<script>
import * as FileDownload from 'downloadjs'
import { mapActions, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import { debounce } from 'lodash'
import moment from 'moment'

export default {
  name: 'customerProfile',
  data() {
    return {
      errors: new Errors(),
      loading: false,
      downloading: false,
      model: {
        date: [
          moment().add(-1, 'month').format('DD-MM-YYYY'),
          moment().format('DD-MM-YYYY'),
        ],
      },
    }
  },
  filters: {
    format_number(value) {
      return `${value.toLocaleString()}`
    },
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('report/customerProfile', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.report.customerProfile.search
      },
      set(newValue) {
        this.$store.commit('report/customerProfile/SET_SEARCH', newValue)
        this.$store.commit('report/customerProfile/RESET_CURRENT_PAGE')
      },
    },
    columns() {
      return [
        { name: this.$t('customerProfile.name') },
        {
          name: this.$t('customerProfile.phoneNumber'),
          style: 'text-align: center',
        },
        {
          name: this.$t('customerProfile.yearOfBorn'),
          style: 'text-align: center',
        },
        {
          name: this.$t('customerProfile.location'),
        },
        {
          name: this.$t('customerProfile.balance'),
          style: 'text-align: right',
        },
        {
          name: this.$t('customerProfile.registeredDate'),
          style: 'text-align: center',
        },
        {
          name: this.$t('customerProfile.isActive'),
          style: 'text-align: center',
        },
      ]
    },
  },
  methods: {
    ...mapActions('report/customerProfile', ['store']),
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch(
          'report/customerProfile/fetch',
          Object.assign(
            {},
            {
              date_from: this.model.date[0],
              date_to: this.model.date[1],
            },
            attributes
          )
        )
        .then(() => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    onDownload() {
      this.errors = new Errors()
      this.downloading = true
      this.store({
        date_from: this.model.date[0],
        date_to: this.model.date[1],
      })
        .then((response) => {
          FileDownload(response, 'customerProfile_customerProfile.xlsx')
        })
        .catch((errorData) => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(errorData))
          )
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.downloading = false
        })
    },
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500),
    'model.date': function (val) {
      if (val) {
        this.fetchData()
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('report/customerProfile/RESET_STATE')
    next()
  },
}
</script>

<style lang="css" scoped>
#list {
  min-height: 50vh;
  max-height: 60vh;
}
</style>